<template>
  <section
    v-if="showTips"
    class="fixed bottom-5 right-10 z-50 flex items-end flex-col transition-all"
  >
    <div
      v-show="tip"
      class="mr-14 mb-3 w-[70%] bg-white rounded-md border overflow-hidden shadow-lg p-5 flex flex-col gap-3 transition-all"
    >
      <p class="font-bold text-lg">{{ text.title }}</p>
      <p>{{ text.subtitle }}</p>
    </div>
    <img
      class="w-20 h-20 cursor-pointer hover:opacity-75 transition-all animate-bounce-short"
      :src="require('@/assets/images/info-audio-quiz.svg')"
      @mouseover="tip = true"
      @mouseleave="tip = false"
    />
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "questionInfo",
  props: {
    showTips: { type: Boolean, default: true },
  },
  data() {
    return {
      tip: false as boolean,
      timer: 2500 as number,
      initText: {
        title: "Responda também por áudio",
        subtitle:
          "Para responder por áudio diga “Responder” e depois diga a resposta do item ou fale “Marque o item X”",
      } as any,
      text: {} as any,
    };
  },
  mounted() {
    this.initBubble();
    this.text = this.initText;
  },
  methods: {
    showText(text?: any, timer?: number): void {
      if (text) {
        this.text = text;
      }
      if (timer) {
        this.timer = timer;
      }
      this.initBubble();
    },
    initBubble(): void {
      this.tip = true;
      setTimeout(() => {
        this.tip = false;
        this.text = this.initText;
      }, this.timer);
    },
  },
});
</script>
